import { render, staticRenderFns } from "./SectionText.vue?vue&type=template&id=a6c9ddac&scoped=true&"
import script from "./SectionText.vue?vue&type=script&lang=js&"
export * from "./SectionText.vue?vue&type=script&lang=js&"
import style0 from "./SectionText.vue?vue&type=style&index=0&id=a6c9ddac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6c9ddac",
  null
  
)

export default component.exports